<template>
<el-row class="header-row">
    <el-col class="logo-container">
        <a href="https://www.berst.io/" target="_blank">
            <img class="vf-logo" src="/favicon-large.png">
        </a>
    </el-col>
    <span class="timer-container" v-if="!restrictControlsForAnonymousUsers">
        <TimerClock v-if="this.mainRoomTimer" :timer="this.mainRoomTimer" />
    </span>
    <!-- <el-col class="lobby-container" v-if="!restrictControlsForAnonymousUsers">
        <span></span>
    </el-col> -->
    <el-col class="header-center-container" >
        <span  class="topic" v-if="!restrictControlsForAnonymousUsers">
            <Topic />
        </span>
        <span class="icons" v-if="!restrictControlsForAnonymousUsers">
            <Lock v-if="controls['ADD_PASSWORD_LOCK']"/>
            <Key :current-room="room" v-if="controls['ADD_PASSWORD_LOCK']"/>
            <Share />
        </span>
    </el-col>
   
    <el-col class="profile-dropdown">
        <Profile v-if="loggedIn"/> 
        <User v-else/>
    </el-col>
</el-row>
</template>

<script>
import Topic from "./Topic";
import Lock from "./Lock";
import Key from "./Key";
import Share from "./Share";
import Profile from "./Profile";
import User from "../../authentication/User";
import {
    mapState
} from "vuex";
import TimerClock from "../timer/TimerClock";

export default {
    name: "Header",
    components: {
        Topic,
        Lock,
        Key,
        Share,
        User,
        Profile,
        TimerClock
    },
    computed:{
        ...mapState({
            room: state => state.rooms.currentRoom,
            allRooms: state => state.rooms.rooms,
            restrictControlsForAnonymousUsers: state => state.mainRoomConfig.currentRoom.restrictControlsForAnonymousUsers && !state.user.profile.loggedIn,
            loggedIn: state => state.user.profile.loggedIn,
            controls: state => state.user.controls,
        }),
        mainRoomTimer: function(){
            const mainRoom = this.allRooms.find(room => !room.parent)
            return mainRoom && mainRoom.timer
        }
    }
}
</script>

<style scoped>
.header-row {
    position: relative;
    display: flex;
    align-items: center;
    background-color: #2A2A3D;
    color: #E7E6FA;
    font-size: 16px;
    line-height: 20px;
    height: 56px;
    min-height: 56px;
}

.logo-container {
    display: flex;
    padding: 0 0 0 8px;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    width: auto;
}
.logo-container a{
    display: inline-flex;    
}

.header-center-container{
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: center;
}

.lobby-container{
    /* width: 4.5%; */
    height: 100%;
    padding: 10px 0;
    text-align: left;
    display: none;
}

.timer-container {
    padding-left: 35px;
}

.vf-logo {
    width: 40px;
    height: 40px;
}
.topic {
    display: flex;
    justify-content: center;
    /* width: 36.333%; */
    height: 100%;
    padding: 2.5px 0;
    align-items: center;
}
.icons {
    height: 100%;
    padding: 0 0 0 8px;
    display: flex;
    align-items: center;
    /* width: 22.15%; */
}
.profile-dropdown {
    width: 48px;
    height: 100%;
    /* background: #1C1C29; */
    /* position: absolute; */
    /* right: 0; */
    display: flex;
    align-items: center;
}

@media (max-width: 767px){
    .lobby-container{
        display: none;
    }
    .header-center-container{
        justify-content: flex-start;
    }
    .icons{
        display: none;
    }
    .timer-container{
        display: none;
    }
}

@media (hover: none) {
    .lobby-container{
        display: none;
    }
    .header-center-container{
        justify-content: flex-start;
    }
    .icons{
        display: none;
    }
    .timer-container{
        display: none;
    }
}
</style>

<style scoped>
/* Child component styles */
>>>label {
    display: inline-block;
    font-size: 16px;
    line-height: 20px;
    color: #E7E6FA;
    margin-bottom: 6px;
}

>>>.btn {
    margin-right: 8px;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background-color: #3E3E52;
    padding: 6px 8px;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
}

>>>.btn:hover {
    background-color: #51516B;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
}

>>>.btn:active,
>>>.btn:focus {
    background: #51516B;
    border: 1px solid #2E2E4D;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), inset 0px 0px 8px rgba(0, 0, 0, 0.25);
}
</style>
